module.exports = __webpack_public_path__ + "media/assets/images/flags/ki-94c6986d8546ca639a2e52872893e192.svg";